var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invalid-link"},[_c('i',{staticClass:"icon-Aula_close icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n    "+_vm._s(_vm.$getText('AULA_THIS_LINK_IS_INVALID'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }